var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-toolbar',{attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v("Kira Bilgileri")]),_c('v-row',{attrs:{"justify":"center"}}),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }